import { Fragment, type ReactElement } from 'react';

interface SizeRemainingSummaryProps {
  readonly remaining: readonly {
    readonly sizeOptionId: string;
    readonly sizeName: string;
    readonly remaining: number;
  }[];
}

export const SizeRemainingSummary = ({ remaining }: SizeRemainingSummaryProps): ReactElement => (
  <p role="status" aria-label="사이즈별 남은 수량" className="text-sm tabular-nums">
    남은 수량:{' '}
    {remaining.map((row, index) => (
      <Fragment key={row.sizeOptionId}>
        {index > 0 ? ' · ' : null}
        <span className={row.remaining < 0 ? 'text-destructive' : undefined}>
          {row.sizeName} {row.remaining}개
        </span>
      </Fragment>
    ))}
  </p>
);
